/** Short-lived cart navigation state ONLY, never price, purchase or payment
 * authority. Rebuilt against the current published source-backed catalog. */
export type PendingStoreCart={
  location:string;items:Array<{kind:'service'|'package';id:string;quantity:number}>;
  savedAt:number;
};
const key='ecfs.public.pendingStoreCart.v1';
const ttl=15*60*1000;
const uuid=/^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
export function readPendingStoreCart():PendingStoreCart|null{
  try{
    const raw=window.sessionStorage.getItem(key);
    if(!raw)return null;
    const saved=JSON.parse(raw) as PendingStoreCart;
    if(!saved||!Number.isFinite(saved.savedAt)||
      saved.savedAt>Date.now()+60000||Date.now()-saved.savedAt>ttl||
      !/^[A-Z0-9_-]{2,64}$/.test(saved.location)||
      !Array.isArray(saved.items)||saved.items.length<1||saved.items.length>30||
      saved.items.some(x=>!x||!['service','package'].includes(x.kind)||
        !uuid.test(x.id)||!Number.isInteger(x.quantity)||
        x.quantity<1||x.quantity>20)){
      window.sessionStorage.removeItem(key);return null;
    }
    return saved;
  }catch{return null;}
}
export function savePendingStoreCart(location:string,items:PendingStoreCart['items']){
  try{window.sessionStorage.setItem(key,JSON.stringify({
    location,items,savedAt:Date.now(),
  }));}catch{/* no payment state kept here */}
}
export function clearPendingStoreCart(){
  try{window.sessionStorage.removeItem(key);}catch{/* no storage */}
}
